module.exports = __webpack_public_path__ + "static/img/pic_news2.723bd4a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsMore/pic_news2.jpg
// module id = J4dQ
// module chunks = 0